/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pre-assessment.reducer';

export const PreAssessment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const preAssessmentList = useAppSelector(state => state.preAssessment.entities);
  const loading = useAppSelector(state => state.preAssessment.loading);
  const totalItems = useAppSelector(state => state.preAssessment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pre-assessment-heading" data-cy="PreAssessmentHeading">
        <Translate contentKey="tinyMedicRestApp.preAssessment.home.title">Pre Assessments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.preAssessment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pre-assessment/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.preAssessment.home.createLabel">Create new Pre Assessment</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.preAssessment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {preAssessmentList && preAssessmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('physicalActivity')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.physicalActivity">Physical Activity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('physicalActivity')} />
                </th>
                <th className="hand" onClick={sort('habbits')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.habbits">Habbits</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('habbits')} />
                </th>
                <th className="hand" onClick={sort('habbitDetails')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.habbitDetails">Habbit Details</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('habbitDetails')} />
                </th>
                <th className="hand" onClick={sort('sexualAbuse')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.sexualAbuse">Sexual Abuse</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sexualAbuse')} />
                </th>
                <th className="hand" onClick={sort('sexualAbuseDetails')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.sexualAbuseDetails">Sexual Abuse Details</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sexualAbuseDetails')} />
                </th>
                <th className="hand" onClick={sort('exposureToPets')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.exposureToPets">Exposure To Pets</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exposureToPets')} />
                </th>
                <th className="hand" onClick={sort('exposureToPetsDetails')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.exposureToPetsDetails">Exposure To Pets Details</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exposureToPetsDetails')} />
                </th>
                <th className="hand" onClick={sort('nutritionType')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.nutritionType">Nutrition Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('nutritionType')} />
                </th>
                <th className="hand" onClick={sort('pastSurgicalHistory')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.pastSurgicalHistory">Past Surgical History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pastSurgicalHistory')} />
                </th>
                <th className="hand" onClick={sort('systemicExamination')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.systemicExamination">Systemic Examination</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('systemicExamination')} />
                </th>
                <th className="hand" onClick={sort('cardiovascularSystem')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.cardiovascularSystem">Cardiovascular System</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cardiovascularSystem')} />
                </th>
                <th className="hand" onClick={sort('respiratorySystem')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.respiratorySystem">Respiratory System</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('respiratorySystem')} />
                </th>
                <th className="hand" onClick={sort('centralNervousSystem')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.centralNervousSystem">Central Nervous System</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('centralNervousSystem')} />
                </th>
                <th className="hand" onClick={sort('abdomen')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.abdomen">Abdomen</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('abdomen')} />
                </th>
                <th className="hand" onClick={sort('genitalNRectum')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.genitalNRectum">Genital N Rectum</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('genitalNRectum')} />
                </th>
                <th className="hand" onClick={sort('skin')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.skin">Skin</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('skin')} />
                </th>
                <th className="hand" onClick={sort('pulse')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.pulse">Pulse</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pulse')} />
                </th>
                <th className="hand" onClick={sort('extremities')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.extremities">Extremities</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('extremities')} />
                </th>
                <th className="hand" onClick={sort('back')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.back">Back</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('back')} />
                </th>
                <th className="hand" onClick={sort('uncommonSymptoms')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.uncommonSymptoms">Uncommon Symptoms</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uncommonSymptoms')} />
                </th>
                <th className="hand" onClick={sort('weightChanges')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.weightChanges">Weight Changes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightChanges')} />
                </th>
                <th className="hand" onClick={sort('fever')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.fever">Fever</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fever')} />
                </th>
                <th className="hand" onClick={sort('ageOfLastChild')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.ageOfLastChild">Age Of Last Child</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageOfLastChild')} />
                </th>
                <th className="hand" onClick={sort('obstetricPara')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.obstetricPara">Obstetric Para</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('obstetricPara')} />
                </th>
                <th className="hand" onClick={sort('obstetricGravida')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.obstetricGravida">Obstetric Gravida</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('obstetricGravida')} />
                </th>
                <th className="hand" onClick={sort('abortions')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.abortions">Abortions</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('abortions')} />
                </th>
                <th className="hand" onClick={sort('sourceOfHistory')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.sourceOfHistory">Source Of History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sourceOfHistory')} />
                </th>
                <th className="hand" onClick={sort('chiefComplaints')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.chiefComplaints">Chief Complaints</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chiefComplaints')} />
                </th>
                <th className="hand" onClick={sort('historyOfPresentIllness')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.historyOfPresentIllness">History Of Present Illness</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyOfPresentIllness')} />
                </th>
                <th className="hand" onClick={sort('medicalHistory')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.medicalHistory">Medical History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicalHistory')} />
                </th>
                <th className="hand" onClick={sort('familyHistory')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.familyHistory">Family History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('familyHistory')} />
                </th>
                <th className="hand" onClick={sort('admissiondiagnosis')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.admissiondiagnosis">Admissiondiagnosis</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('admissiondiagnosis')} />
                </th>
                <th className="hand" onClick={sort('historyOfImmunization')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.historyOfImmunization">History Of Immunization</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyOfImmunization')} />
                </th>
                <th className="hand" onClick={sort('medicineReviewed')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.medicineReviewed">Medicine Reviewed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicineReviewed')} />
                </th>
                <th className="hand" onClick={sort('assessmentType')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.assessmentType">Assessment Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('assessmentType')} />
                </th>
                <th className="hand" onClick={sort('code')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.code">Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('code')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('consciousness')}>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.consciousness">Consciousness</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consciousness')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.gynicHistory">Gynic History</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preAssessment.obstetricEvent">Obstetric Event</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {preAssessmentList.map((preAssessment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pre-assessment/${preAssessment.id}`} color="link" size="sm">
                      {preAssessment.id}
                    </Button>
                  </td>
                  <td>{preAssessment.microSec}</td>
                  <td>{preAssessment.timestampentry}</td>
                  <td>{preAssessment.lastupdated}</td>
                  <td>{preAssessment.cursor}</td>
                  <td>{preAssessment.active ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PhysicalActivity.${preAssessment.physicalActivity}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Habbits.${preAssessment.habbits}`} />
                  </td>
                  <td>{preAssessment.habbitDetails}</td>
                  <td>{preAssessment.sexualAbuse ? 'true' : 'false'}</td>
                  <td>{preAssessment.sexualAbuseDetails}</td>
                  <td>{preAssessment.exposureToPets ? 'true' : 'false'}</td>
                  <td>{preAssessment.exposureToPetsDetails}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.NutritionType.${preAssessment.nutritionType}`} />
                  </td>
                  <td>{preAssessment.pastSurgicalHistory}</td>
                  <td>{preAssessment.systemicExamination}</td>
                  <td>{preAssessment.cardiovascularSystem}</td>
                  <td>{preAssessment.respiratorySystem}</td>
                  <td>{preAssessment.centralNervousSystem}</td>
                  <td>{preAssessment.abdomen}</td>
                  <td>{preAssessment.genitalNRectum}</td>
                  <td>{preAssessment.skin}</td>
                  <td>{preAssessment.pulse}</td>
                  <td>{preAssessment.extremities}</td>
                  <td>{preAssessment.back}</td>
                  <td>{preAssessment.uncommonSymptoms}</td>
                  <td>{preAssessment.weightChanges}</td>
                  <td>{preAssessment.fever}</td>
                  <td>{preAssessment.ageOfLastChild}</td>
                  <td>{preAssessment.obstetricPara}</td>
                  <td>{preAssessment.obstetricGravida}</td>
                  <td>{preAssessment.abortions}</td>
                  <td>{preAssessment.sourceOfHistory}</td>
                  <td>{preAssessment.chiefComplaints}</td>
                  <td>{preAssessment.historyOfPresentIllness}</td>
                  <td>{preAssessment.medicalHistory}</td>
                  <td>{preAssessment.familyHistory}</td>
                  <td>{preAssessment.admissiondiagnosis}</td>
                  <td>{preAssessment.historyOfImmunization}</td>
                  <td>{preAssessment.medicineReviewed ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AssessmentType.${preAssessment.assessmentType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TriageCode.${preAssessment.code}`} />
                  </td>
                  <td>{preAssessment.addedById}</td>
                  <td>{preAssessment.modifiedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${preAssessment.addedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${preAssessment.modifiedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SedationScore.${preAssessment.consciousness}`} />
                  </td>
                  <td>
                    {preAssessment.admission ? (
                      <Link to={`/admission/${preAssessment.admission.id}`}>{preAssessment.admission.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preAssessment.gynicHistory ? (
                      <Link to={`/gynic-history/${preAssessment.gynicHistory.id}`}>{preAssessment.gynicHistory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preAssessment.obstetricEvent ? (
                      <Link to={`/obstetric-event/${preAssessment.obstetricEvent.id}`}>{preAssessment.obstetricEvent.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/pre-assessment/${preAssessment.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pre-assessment/${preAssessment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pre-assessment/${preAssessment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.preAssessment.home.notFound">No Pre Assessments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={preAssessmentList && preAssessmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PreAssessment;
